import {PricingItem} from "../../../domain/in/quote/pricing-item/pricing-item";

export class OrderedSynthesisService {

    public static sortCustomGroups(customGroups: any[], serviceCode : string): any[] {
        return (customGroups ?? []).map(g =>
            this.cloneWithSameProto(g, { pricingItems: this.sortByDisplayOrder(g.pricingItems) })
        );
    }

    static sortByDisplayOrder(items?: PricingItem[]): PricingItem[] {
        return [...(items ?? [])].sort(
            (a, b) => Number(a.displayOrder ?? 0) - Number(b.displayOrder ?? 0)
        );
    }

    static cloneWithSameProto<T extends object, P extends Partial<T>>(obj: T, patch: P): T {
        return Object.assign(Object.create(Object.getPrototypeOf(obj)), obj, patch);
    }

}
